import { UsersModule } from '@/components/modules/Users/Users';
import { DYNAMIC_PAGE_PATHS } from '@/components/views/DynamicPageView/config/shared/pathRoutes';
import { APP_ROLES, APP_USER_TYPES } from '@/config/config';
import { PageScheme } from '@/config/types';

export const PAGE_USERS: PageScheme = {
  path: DYNAMIC_PAGE_PATHS.USERS,
  schemesByRoles: [
    {
      roles: [APP_ROLES.MERCHANT, APP_ROLES.CHANNEL],
      titleTextId: 'USERS',
      widgets: [],
    },
  ],
  sections: [
    {
      textId: '',
      module: (
        <UsersModule
          permissions={{
            view: [APP_USER_TYPES.MERCHANT, APP_USER_TYPES.MERCHANT_GROUP, APP_USER_TYPES.CHANNEL],
            edit: [APP_ROLES.MERCHANT, APP_ROLES.MERCHANT_GROUP, APP_ROLES.CHANNEL],
          }}
        />
      ),
    },
  ],
};
